
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech-salary-survey-2025",
      function () {
        return require("private-next-pages/tech-salary-survey-2025/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech-salary-survey-2025"])
      });
    }
  